import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../lib/session";

/**
 * 물건 화면 앞의 가드.
 *
 * 이 가드는 사용자 편의를 위한 것이다. 실제 차단은 서버의 requireMember 와
 * DB 의 RLS 가 한다. 여기를 우회해도 데이터는 나오지 않는다.
 *
 * 골격 모드(인증 미구성)에서는 통과시킨다. 그 상태에서 보이는 것은
 * 가상 샘플뿐이다.
 */
export default function RequireMember() {
  const { state } = useSession();
  const location = useLocation();

  if (state.kind === "loading") {
    return <p className="py-10 text-[13px] text-ink-soft">확인 중</p>;
  }

  if (state.kind === "skeleton" || state.kind === "member") {
    return <Outlet />;
  }

  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
